import { IncentivesScreen } from "@/components/incentives/IncentivesScreen";

export function IncentivesPage() {
  return <IncentivesScreen />;
}
